export default __webpack_public_path__ + "img/unchecked.3c7787c7.svg";